import { getAmplitudeInstance } from '@alltrails/shared/utils/amplitudeHelpers';
import { MapStatsUtil } from './map_stats_util';
import { SearchFiltersUtil } from './search_filters_util';
import {
  EXPLORE_COMMUNITY_CONTENT_CLICKED,
  EXPLORE_COMMUNITY_CONTENT_ITEM_CLICKED,
  EXPLORE_FILTER_SHEET_VIEWED,
  EXPLORE_FILTERS_APPLIED,
  EXPLORE_MAP_PAN_END,
  EXPLORE_SEARCH_BOX_CLICKED
} from './constants/AmplitudeEvent';
import { FILTER, LOCATION_PAGE, MAP_PAN } from './constants/SearchAnalyticsConstants';

const logCommunityContentClicked = () => {
  getAmplitudeInstance().logEvent(EXPLORE_COMMUNITY_CONTENT_CLICKED);
};

const logCommunityContentItemClicked = (item, idx) => {
  getAmplitudeInstance().logEvent(EXPLORE_COMMUNITY_CONTENT_ITEM_CLICKED, { 'item id': item.ID, 'item type': item.type, 'item position': idx });
};

const logFilterSheetViewed = source => {
  getAmplitudeInstance().logEvent(EXPLORE_FILTER_SHEET_VIEWED, { 'search origin': source });
};

const logFiltersApplied = (filters, numReults, resultsLimit, center, searchRadius, source) => {
  const activityFilters = SearchFiltersUtil.getSelectedActivityFilterValues(filters);
  const difficultyFilters = SearchFiltersUtil.getSelectedDifficultyFilterValues(filters);
  const attractionFilters = SearchFiltersUtil.getSelectedAttractionsFilterValues(filters);
  const suitabilityFilters = SearchFiltersUtil.getSelectedSuitabilityFilterValues(filters);
  const routeTypeFilters = SearchFiltersUtil.getSelectedRouteFilterValues(filters);
  const trailTrafficFilters = SearchFiltersUtil.getSelectedTrailTrafficFilterValues(filters);
  const completionFilters = SearchFiltersUtil.getSelectedCompletedFilterValues(filters);
  getAmplitudeInstance().logEvent(EXPLORE_FILTERS_APPLIED, {
    'sort filters': SearchFiltersUtil.getSelectedSortFilter(filters),
    'num filters selected': SearchFiltersUtil.getNumSelectedFilters(filters),
    'search origin': source,
    'num results returned': numReults,
    'limit filters': resultsLimit,
    'location filters': JSON.stringify(
      center != null || searchRadius != null
        ? {
            lat: center?.lat ?? null,
            lng: center?.lng ?? null,
            radius: searchRadius
          }
        : null
    ),
    'activity type filters': JSON.stringify(activityFilters.length ? activityFilters : null),
    'difficulty filters': JSON.stringify(difficultyFilters.length ? difficultyFilters : null),
    'length filters': JSON.stringify(
      SearchFiltersUtil.hasAlteredSliderFilter(filters.lengths)
        ? {
            min: MapStatsUtil.metersToMiles(filters.lengths.value[0]),
            max: MapStatsUtil.metersToMiles(filters.lengths.value[1])
          }
        : null
    ),
    'elevation filters': JSON.stringify(
      SearchFiltersUtil.hasAlteredSliderFilter(filters.elevation_gain)
        ? {
            min: MapStatsUtil.metersToFeet(filters.elevation_gain.value[0]),
            max: MapStatsUtil.metersToFeet(filters.elevation_gain.value[1])
          }
        : null
    ),
    'rating filters': filters.minRating,
    'attractions filters': JSON.stringify(attractionFilters.length ? attractionFilters : null),
    'suitability filters': JSON.stringify(suitabilityFilters.length ? suitabilityFilters : null),
    'route type filters': JSON.stringify(routeTypeFilters.length ? routeTypeFilters : null),
    'trail traffic filters': JSON.stringify(trailTrafficFilters.length ? trailTrafficFilters : null),
    'trail completion filters': JSON.stringify(completionFilters.length ? completionFilters : null)
  });
};

const logMapPanEnd = (filters, numResults, center) => {
  getAmplitudeInstance().logEvent(EXPLORE_MAP_PAN_END, {
    ...center,
    'zoom level': filters.zoomLevel,
    'num results returned': numResults
  });
};

const logSearchBoxClicked = (source, onLocationPage) => {
  const searchBoxLocation = onLocationPage ? LOCATION_PAGE : source;
  getAmplitudeInstance().logEvent(EXPLORE_SEARCH_BOX_CLICKED, { 'search origin': searchBoxLocation });
};

const logSearchResultsAnalytics = (filters, results, resultsLimit, center, searchRadius, source, searchTrigger) => {
  const centerCoords = center ? { lat: center[0], lng: center[1] } : null;
  switch (searchTrigger) {
    case MAP_PAN:
      logMapPanEnd(filters, results.length, centerCoords);
      break;
    case FILTER:
      logFiltersApplied(filters, results.length, resultsLimit, centerCoords, searchRadius, source);
      break;
    default:
    // Do nothing - no other search analytics to log
  }
};

export { logCommunityContentClicked, logCommunityContentItemClicked, logFilterSheetViewed, logSearchBoxClicked, logSearchResultsAnalytics };
